import { render, staticRenderFns } from "./AddressGrid.vue?vue&type=template&id=1a784f58"
import script from "./AddressGrid.vue?vue&type=script&lang=js"
export * from "./AddressGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports